export const teamsDeepLinkUrlPathForChat = '/l/chat/0/0';
export const teamsDeepLinkUsersUrlParameterName = 'users';
export const teamsDeepLinkTopicUrlParameterName = 'topic';
export const teamsDeepLinkMessageUrlParameterName = 'message';
